/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Teams_ModifyInputs */

const en_enum_permission_name_teams_modify = /** @type {(inputs: Enum_Permission_Name_Teams_ModifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Teams Modify`)
};

const de_enum_permission_name_teams_modify = /** @type {(inputs: Enum_Permission_Name_Teams_ModifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Teams Modify`)
};

/**
* | output |
* | --- |
* | "Name Teams Modify" |
*
* @param {Enum_Permission_Name_Teams_ModifyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_teams_modify = /** @type {((inputs?: Enum_Permission_Name_Teams_ModifyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Teams_ModifyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_teams_modify(inputs)
	return de_enum_permission_name_teams_modify(inputs)
});